import analyticsHelper from '@spa/utils/analyticsHelper';
import {setCommonMetrics} from '@spa/features/search_job/pc/api/analytics/base';
import {isRefererHostMatchingAppHost} from '@spa/utils/urlHelper';

/**
 * 検索結果ページ表示の計測
 */
export const trackSearchResult = (searchResultViewModel) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        const analyticsViewModel = searchResultViewModel.analyticsViewModel;
        const metaTextViewModel = searchResultViewModel.metaTextViewModel;
        const contentGroup = analyticsViewModel.contentGroup || analyticsViewModel.channelName;
        s.channel = analyticsViewModel.channelName;
        s.prop1 = contentGroup;
        s.prop2 = `${contentGroup},${searchResultViewModel.currentPage}`;
        s.prop3 = analyticsViewModel.jobType;
        s.prop4 = analyticsViewModel.salary;
        s.prop5 = analyticsViewModel.datePosted;
        s.prop6 = `${contentGroup},${searchResultViewModel.hitCount}`;
        // 外部からの流入の場合のみprop7をセット
        if (!isRefererHostMatchingAppHost()) {
            s.prop7 = `entry_${s.prop1}`;
        }
        s.prop8 = analyticsViewModel.distance;
        s.prop9 = metaTextViewModel.isIndex ? '1' : '0';
        s.prop10 = analyticsViewModel.feature;
        s.prop11 = analyticsViewModel.keyword;
        s.prop12 = analyticsViewModel.location;
        s.prop13 = `${analyticsViewModel.keyword}|${analyticsViewModel.location}`;
        s.prop15 = analyticsViewModel.locationType;
        s.prop16 = analyticsViewModel.location1;
        s.prop17 = analyticsViewModel.location2;
        s.prop18 = analyticsViewModel.location3;
        s.prop19 = analyticsViewModel.location4;
        s.prop21 = searchResultViewModel.relatedKeywordListViewModel.list.length;
        s.prop46 = searchResultViewModel.jobViewModelList.length;
        s.prop55 = analyticsViewModel.responseTime;
        s.eVar46 = s.prop46;
        s.eVar49 = s.prop1;
        s.list1 = analyticsViewModel.jobUniqueIdList;
        s.list2 = searchResultViewModel.relatedKeywordListViewModel.implodedText;
        s.events = `event301=${searchResultViewModel.jobViewModelList.length}`;
        s.t();
    });
};

/**
 * 求人詳細表示（正常）の計測
 * @param {JobDetailData} JobDetailData
 */
export const trackJobDetail = (JobDetailData) => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        const analyticsViewModel = JobDetailData.analyticsViewModel;

        s.channel = analyticsViewModel.channelName;
        s.prop1 = analyticsViewModel.channelName;
        s.prop2 = `${analyticsViewModel.channelName},searchresult_jobview`;
        // 外部からの流入の場合のみprop7をセット
        if (!isRefererHostMatchingAppHost()) {
            s.prop7 = `entry_${s.prop1}`;
        }
        s.prop9 = String(analyticsViewModel.isIndex);
        s.prop31 = analyticsViewModel.uniqueId;
        s.prop32 = analyticsViewModel.sourceName;
        s.prop38 = analyticsViewModel.jobTypes;
        s.prop39 = analyticsViewModel.salary;
        s.prop41 = JobDetailData.locations && JobDetailData.locations.length ? JobDetailData.locations[0] : 'not_set'; // 複数勤務地化の影響により、画面側から先頭勤務地を計測
        s.prop45 = analyticsViewModel.type;
        s.eVar49 = s.prop1;
        s.eVar45 = s.prop45;
        s.t();
    });
};

/**
 * 求人詳細エラー表示の計測
 */
export const trackJobDetailError = () => {
    analyticsHelper.trackEvent(() => {
        const s = s_gi(s_account);
        s.clearVars();

        setCommonMetrics();
        s.channel = 'jobdetail';
        s.prop1 = `${s.channel}_error`;
        s.prop2 = `${s.channel},searchresult_jobview`;
        // s.prop57を削除
        s.prop57 = '';
        s.eVar49 = s.prop1;

        s.t();
    });
};
